// options.js

import { ref, computed, onMounted, onUnmounted } from 'vue'
import { useStore } from 'vuex'

export default {
    props: {
        campaignId: String,
        title: String,
        description: String,
        centerImage: {
            type: Array,
            default: () => []
        },
        nonCenteredImages: {
            type: Array,
            default: () => []
        },
        linkUrl: String,
        linkText: String,
        linkTitle: String,
        linkTarget: {
            type: String,
            default: '_self'
        }
    },

    setup(props) {
        const store = useStore()

        // ——— donation counter ———
        const fundraisingAmount = ref(0)
        const updateAmount = () => {
            store
              .dispatch('fundraising/GetHighlightedDonations', {
                fundraisingCampaignId: props.campaignId
              })
              .then((sum) => (fundraisingAmount.value = Math.floor(sum)))
              .catch((err) => console.error('Fetch error:', err))
        }

        const digitGroups = computed(() => {
            const raw = fundraisingAmount.value.toString()
            const groups = raw.match(/\d{1,3}(?=(?:\d{3})*$)/g) || []
            return groups.map((g, i) => (i === 0 ? g : g.padStart(3, '0')))
        })

        const width = ref(window.innerWidth)
        const onResize = () => (width.value = window.innerWidth)
        const imageKey = computed(() =>
            width.value > 800 ? 0 : width.value > 768 ? 1 : 2
        )

        let intervalId
        let initialTimeoutId

        onMounted(() => {
            window.addEventListener('resize', onResize)

            updateAmount()
            intervalId = setInterval(updateAmount, 5000)
        })

        onUnmounted(() => {
            clearTimeout(initialTimeoutId)
            clearInterval(intervalId)
            window.removeEventListener('resize', onResize)
        })

        return {
            ...props,
            fundraisingAmount,
            digitGroups,
            width,
            imageKey
        }
    }
}
